export default class PaymentStatus {
  static get Wait () { return 'wait' }
  static get Success () { return 'success' }
  static get Cancel () { return 'cancel' }
  static get Refund () { return 'refund' }

  static getName (enumValue) {
    switch (enumValue) {
      case PaymentStatus.Wait:
        return 'Ожидает оплаты'

      case PaymentStatus.Success:
        return 'Оплачен'

      case PaymentStatus.Cancel:
        return 'Отменен'

      case PaymentStatus.Refund:
        return 'Возврат'

      default:
        return enumValue
    }
  }
}
